<template>
  <div :class="classes">
    <pt-page-title title="直播详情"></pt-page-title>
    <div v-if="currentLive">
      <pt-sub-title title="直播信息"></pt-sub-title>
      <pt-form-item class="special" label="直播标题：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentLive.name}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="直播封面：" :labelWidth="labelWidth" v-if="currentLive.imageUrl"
        :lineHeight="lineHeight">
        <pt-img :src="$publicResourcesUrl + currentLive.imageUrl" :isPublic="true" class="quaImages"></pt-img>
      </pt-form-item>
       <pt-form-item class="special" label="主讲人：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentLive.speaker}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="开始时间：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentLive.start_copy}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="结束时间：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentLive.end_copy}}</span>
      </pt-form-item>
       <pt-form-item class="special" label="第三方链接：" :labelWidth="labelWidth" :lineHeight="lineHeight">
         {{currentLive.link}}
        <pt-copy-button style="padding-top:0;padding-bottom:0;" type="text"
          :copyContent="currentLive.link" text="点击复制"></pt-copy-button>
      </pt-form-item>
    </div>
    <div class="marginTop">
      <el-button type="primary" @click="goEdit(currentLive)">编辑</el-button>
      <el-button type="danger" plain @click="goDelete(currentLive)">删除</el-button>
    </div>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-live-list-detail'

export default {
  name: 'pt-live-list-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    value (val) {
      this.currentLive = val
    }
  },
  data () {
    return {
      labelWidth: '150px',
      lineHeight: '50',
      currentLive: this.value
    }
  },
  methods: {
    goEdit (val) {
      this.$router.push('/live-list/live-list-form/true/' + val.id)
    },
    goDelete (row) {
      this.$emit('deleteLive', row)
    }
  }
}
</script>

<style lang="less">
@import '~less/var.less';
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .pt-live-list-detail{
  .special >span{
    color:@mainColor;
  }
  .quaImages{
    width:204px;
    height: 128px;
  }
  .pictureNames{
    display: flex;
    margin:0;
    padding-left: 0;
    li{
      width:204px;
      line-height: 20px;
      text-align: center;
    }
  }
}
</style>
